import React from "react";
import { FaCheck, FaSolarPanel } from "react-icons/fa6";
import Reveal from "./Reveal";
import { trackEvent } from "../lib/analytics";
import imgPaneles from "../assets/images/bomba-solar-paneles.jpeg";
import imgPoste from "../assets/images/bomba-solar-poste.jpeg";
import imgCanal from "../assets/images/bomba-solar-canal.jpeg";
import imgPozo from "../assets/images/bomba-solar-pozo.jpeg";
import imgCampo from "../assets/images/bomba-solar-campo.jpeg";
import imgInversor from "../assets/images/bomba-solar-inversor.jpeg";

// TODO: revisar el texto — es un borrador. Confirmar potencias/capacidades
// reales de los equipos que instalan.
const ventajas = [
  "Sin costo de combustible ni de conexión a la red eléctrica",
  "Ideal para pozos, molinos y tomas de agua alejadas del campo",
  "Bajo mantenimiento: sin motor a combustión que revisar",
  "Se dimensiona según el caudal y la altura de elevación que necesite",
];

const fotos = [
  { src: imgPaneles, alt: "Fila de paneles solares instalados a campo abierto para alimentar una bomba de riego" },
  { src: imgPozo, alt: "Agua saliendo a presión de un pozo con bomba alimentada por energía solar" },
  { src: imgPoste, alt: "Panel solar sobre poste conectado a una bomba sumergible" },
  { src: imgCampo, alt: "Panel solar instalado en un campo de pastura" },
  { src: imgInversor, alt: "Inversor y controlador de una bomba de riego solar montado sobre la estructura del panel" },
  { src: imgCanal, alt: "Agua bombeada con energía solar saliendo hacia un canal de riego" },
];

const SolarPumps = () => {
  return (
    <section id="bombas-solares" className="bg-white py-20 sm:py-28">
      <div className="container-site">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="section-eyebrow flex items-center justify-center gap-2">
            <FaSolarPanel aria-hidden="true" />
            Nuevo
          </p>
          <h2 className="section-title">Bombas de riego con energía solar</h2>
          <p className="section-lead">
            Para los lotes donde no llega la red eléctrica, instalamos
            equipos de bombeo alimentados 100% por paneles solares —
            la misma agua, sin factura de luz ni generador.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4">
          {fotos.map((foto, i) => (
            <Reveal key={foto.src} delay={i * 60}>
              <img
                src={foto.src}
                alt={foto.alt}
                loading="lazy"
                decoding="async"
                className="aspect-[4/3] w-full rounded-xl object-cover shadow-card transition-transform duration-500 ease-out hover:scale-105"
              />
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="mx-auto mt-14 max-w-3xl">
          <ul className="grid gap-x-8 gap-y-3.5 sm:grid-cols-2">
            {ventajas.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span
                  className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-campo-100 text-campo-700"
                  aria-hidden="true"
                >
                  <FaCheck size={10} />
                </span>
                <span className="text-sm leading-relaxed text-slate-700">
                  {item}
                </span>
              </li>
            ))}
          </ul>

          <div className="mt-9 flex justify-center">
            <a
              href="#contacto"
              onClick={() => trackEvent("cta_click", { location: "bombas_solares" })}
              className="btn-primary"
            >
              Consultar por bombeo solar
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default SolarPumps;
